<template>
  <div class="container">
    <section>
      <MainPage />
    </section>
  </div>
</template>

<script>
import MainPage from "./MainPage.vue";

export default {
  name: "Content",
  data() {
    return {
      title: "Content",
    };
  },

  components: {
    MainPage,
  },
  methods: {},
};
</script>
